import { render, staticRenderFns } from "./ProteinProtein.vue?vue&type=template&id=3fe01337&scoped=true"
import script from "./ProteinProtein.vue?vue&type=script&lang=js"
export * from "./ProteinProtein.vue?vue&type=script&lang=js"
import style0 from "./ProteinProtein.vue?vue&type=style&index=0&id=3fe01337&prod&scoped=true&lang=css"
import style1 from "./ProteinProtein.vue?vue&type=style&index=1&id=3fe01337&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe01337",
  null
  
)

export default component.exports